export const useAudio = () => {
  let audio = new Audio()

  audio.autoplay = true;
  audio.control = false
  audio.style.display = 'none';

  return audio
}
